import LanguageSelectContainer from './LanguageSelectContainer'

export default LanguageSelectContainer


// WEBPACK FOOTER //
// ./src/components/language/index.js